import './vincentian/style';
import FormStructure from './vincentian/form_structure';

export default FormStructure;